<template>
  <tm-skeleton-filters
    v-if="showHeader"
    :left-controls="leftControls"
    :right-controls="rightControls"
  />
  <tm-table-container>
    <tm-table-abstract-skeleton v-bind="$props" />
  </tm-table-container>
</template>

<script setup lang="ts">
import TmSkeletonFilters from '@/components/shared/skeletons/TmSkeletonFilters.vue'
import TmTableAbstractSkeleton from '@/components/shared/tables/TmTableAbstractSkeleton.vue'
import type { TmTableAbstractSkeletonProps } from '@/components/shared/tables/tableBase'
import TmTableContainer from '@/components/shared/tables/TmTableContainer.vue'

withDefaults(
  defineProps<
    TmTableAbstractSkeletonProps & {
      leftControls?: string[]
      rightControls?: string[]
      showHeader?: boolean
    }
  >(),
  {
    hasActions: true,
    showHeader: true,
  },
)
</script>
